import script from "./DocCategoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocCategoryCard.vue?vue&type=script&setup=true&lang=ts"

import "./DocCategoryCard.vue?vue&type=style&index=0&id=2db86c34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2db86c34"]])

export default __exports__